// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"AppSideMenu_menuContainer__3C7SE"};